export default __webpack_public_path__ + "media/components/blocks/EditorsChoiceBlock/star_rating-162e6de59cf4d678ce0cb5a744d6d839.png";